module.exports = __webpack_public_path__ + "img/202501.3ad5b654.png";